import React from "react";

const Area = ({
  width = 20,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 15.75H7.25V16.25H3.75V12.75H4.25V15.25V15.75H4.75ZM15.75 15.25V12.75H16.25V16.25H12.75V15.75H15.25H15.75V15.25ZM11.9964 11.3142L11.8707 11H11.5323H8.46475H8.12613L8.00046 11.3144L7.22688 13.25H6.68845L9.58779 6H10.4107L13.3107 13.25H12.7714L11.9964 11.3142ZM10.4635 7.47818L9.99962 6.31746L9.53506 7.47793L8.59981 9.81418L8.32526 10.5H9.064H10.933H11.6713L11.3973 9.81443L10.4635 7.47818ZM4.25 4.75V7.25H3.75V3.75H7.25V4.25H4.75H4.25V4.75ZM15.25 4.25H12.75V3.75H16.25V7.25H15.75V4.75V4.25H15.25Z"
        fill="#0A0D14"
        stroke="#868C98"
      />
    </svg>
  );
};

export default Area;
